import { ErrorTypography } from '@src/common/components/Typography';
import { theme } from '@src/common/styles/Theme';
import { useTranslation } from 'react-i18next';

export const NoCurrencyAvailable = () => {
  const { t } = useTranslation();

  return (
    <ErrorTypography style={{ color: theme.palette.error.error }}>
      {t('noCurrencyAvailable')}
    </ErrorTypography>
  );
};
